import PayrollDocuments from "../common/PayrollDocuments";

const ManagerPayrollDocuments = () => <PayrollDocuments />;

export default ManagerPayrollDocuments;
